import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=1ec61c11&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTable.vue?vue&type=style&index=0&id=1ec61c11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec61c11",
  null
  
)

export default component.exports